import request from '@/config/axios'

export interface FacilityVO {
  id: string | number
  code: string
  name: string
  category?: string
  icon?: string
  isSystem?: number
  sort?: number
  status?: number
}

// 获取全部设施列表
export const listAll = () => {
  return request.get({ url: '/hotel/facility/list-all' })
}

// 获取设施分页
export const getFacilityPage = (params: any) => {
  return request.get({ url: '/hotel/facility/page', params })
}

// 获取设施详情
export const getFacility = (id: string | number) => {
  return request.get({ url: '/hotel/facility/get?id=' + id })
}

// 新增设施
export const createFacility = (data: FacilityVO) => {
  return request.post({ url: '/hotel/facility/create', data })
}

// 修改设施
export const updateFacility = (data: FacilityVO) => {
  return request.put({ url: '/hotel/facility/update', data })
}

// 删除设施
export const deleteFacility = (id: string | number) => {
  return request.delete({ url: '/hotel/facility/delete?id=' + id })
}
